import {Injectable} from '@angular/core';
import {OccCartAdapter} from '@spartacus/cart/base/occ';
import {Cart} from '@spartacus/cart/base/root';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DcpCartAdapter extends OccCartAdapter {

  create(
    userId: string,
    oldCartId?: string,
    toMergeCartGuid?: string
  ): Observable<Cart> {
    return super.create(userId, undefined, toMergeCartGuid);
  }
}
